'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M48 208l352 0 0 16-240 0 0 208L48 432l0-224zM288 320l32 0 0 16 0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16 0-16 32 0 0 16 0 16c0 47.6-34.6 87.1-80 94.7l0 1.3-16 0c-53 0-96-43-96-96l0-16 0-16z', 'M176 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64-96 0 0-64zm-48 64l-80 0L0 160l0 48L0 432l0 48 48 0 112 0 0-48L48 432l0-224 352 0 0 16 48 0 0-16 0-48-48 0-80 0 0-64c0-53-43-96-96-96s-96 43-96 96l0 64zm448 96l-384 0 0 256 384 0 0-256zM320 336l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16 0-16 32 0 0 16 0 16c0 47.6-34.6 87.1-80 94.7l0 1.3-16 0c-53 0-96-43-96-96l0-16 0-16 32 0 0 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;